import { Button } from '@/shared/ui/button.tsx';
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetTrigger,
} from '@/shared/ui/sheet.tsx'
import { Filter } from 'lucide-react';
import EventFilter from './EventFilter';
import { SuggestedPostFilterType } from '../UnreviewedTab';
import { SetStateAction } from 'react';
import { DateRange } from 'react-day-picker';

type Props = {
  filter: SuggestedPostFilterType,
  setFilter: React.Dispatch<SetStateAction<SuggestedPostFilterType>>,
  categories: string[],
  date: DateRange | undefined,
  setDateFilter: React.Dispatch<SetStateAction<DateRange | undefined>>,
}

const EventFilterSheet = ({ setFilter, filter, categories, date, setDateFilter }: Props) => {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="outline" size="icon" className='flex lg:hidden'>
          <Filter />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className='w-[55vw] md:w-[30vw]'>
        <EventFilter filter={filter} setFilter={setFilter} categories={categories} date={date} setDateFilter={setDateFilter} />
        <SheetFooter>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  )
}

export default EventFilterSheet;
